import React, { useCallback } from 'react';
import { Layout } from 'antd';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import MirrorBrowser from './MirrorBrowser';
import './browsePage.css';

const { Content } = Layout;

export default function BrowsePage() {
  const navigate = useNavigate();
  const location = useLocation();

  // /browse/KaOS/core/ → "KaOS/core/"
  const path = decodeURIComponent(location.pathname.replace(/^\/browse\/?/, ''));

  const handlePathChange = useCallback((newPath) => {
    if (!newPath || newPath === '') {
      navigate('/home');
      return;
    }
    navigate(`/browse/${newPath}`);
  }, [navigate]);

  // Yol boşsa direkt ana sayfaya yönlendir
  if (!path) {
    return (
      <Content className="browse-page">
        <div className="page">
          <main className="card browse-card">
            <div className="card__header">
              <div>
                <h2>Mirror Catalogue</h2>
                <p>Select a mirror from the catalogue to browse its files.</p>
              </div>
              <Link to="/home" className="cta cta--secondary">
                <ArrowLeftOutlined style={{ marginRight: 6 }} />
                Back to Catalogue
              </Link>
            </div>
          </main>
        </div>
      </Content>
    );
  }

  // Kök mirror adı (breadcrumb için)
  const segments = path.split('/').filter(Boolean);
  const mirrorName = segments[0] || '';

  return (
    <Content className="browse-page">
      <div className="page">
        <main className="card browse-card">

          {/* Üst başlık */}
          <div className="card__header">
            <div>
              <h2>
                <span className="browse-title-prefix">Browsing</span>{' '}
                <span className="browse-title-name">{mirrorName}</span>
              </h2>
              <p>Navigate the mirror's directory tree and download files directly.</p>
            </div>
            <Link to="/home" className="cta cta--secondary browse-back-btn">
              <ArrowLeftOutlined style={{ marginRight: 6 }} />
              Back to Catalogue
            </Link>
          </div>

          {/* Dosya gezgini */}
          <MirrorBrowser
            path={path}
            onPathChange={handlePathChange}
          />

        </main>
      </div>
    </Content>
  );
}
